import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import { useEffect, useState } from "react";
import { fetchWorklistRecords } from "../../../services/managerWorkListService";
import CustomPagination from "./CustomPagination";
import { imageIdGenerate } from "../../../utils/custom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
const TOTAL_COLUMNS_COUNT = 10;

const WorkListTable = ({
  parentWorkList,
  changeParentList,
  filterList,
  setWorklistCount,
  filterPagination,
  setFilterPagination,
  dataPerPage,
}) => {
  const [postData, setPostData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    sort_column: "id",
    sort_direction: "ASC",
  });
  const [isLoading, setLoadingState] = useState(false);
  const navigate = useNavigate();

  const isManager = localStorage.getItem("Role") === "Manager";
  const isTeamLead = localStorage.getItem("Role") === "Team Lead";
  const isAuditor = localStorage.getItem("Role") === "Auditor";
  const isRedirectionToManagerWorklistDetails = isManager || isTeamLead;

  const handleRedirect = (worklist_no) => {
    let redirectionPath = "";

    if (isRedirectionToManagerWorklistDetails) {
      redirectionPath = "/manager-worklist-details";
    } else if (isAuditor) {
      redirectionPath = "/auditor-worklist-details";
    }

    navigate(redirectionPath, { state: { worklist_id: worklist_no } });
  };

  useEffect(() => {
    fetchWorklistData(filterList);
  }, [parentWorkList, currentPage, dataPerPage, filterList, sortConfig]);

  const fetchWorklistData = async () => {
    setLoadingState(true);
    let response = {};
    if (filterPagination === true) {
      setCurrentPage(1);
      setFilterPagination(false);
    }

    response = await fetchWorklistRecords(
      filterList,
      currentPage,
      dataPerPage,
      sortConfig.sort_column,
      sortConfig.sort_direction,
    );
    setPostData(response?.data);
    changeParentList(false);
    setWorklistCount(response?.data?.totalRecords);
    setLoadingState(false);
  };

  const currentData = postData?.worklistItem?.slice(0, dataPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const toggleSort = (column) => {
    setSortConfig({
      sort_column: column,
      sort_direction: sortConfig.sort_direction === "ASC" ? "DESC" : "ASC",
    });
  };
  const renderSortIcon = (columnKey) => {
    if (sortConfig.sort_column === columnKey) {
      return sortConfig.sort_direction === "ASC"
        ? "fa fa-sort-up"
        : "fa fa-sort-down";
    } else {
      return "fa fa-sort";
    }
  };

  return (
    <>
      <div className="card-body py-4">
        <div className="table-responsive">
          <table
            className="table to-do-table align-middle table-row-dashed fs-6 gy-5 gs-7"
            id="kt_table_users"
          >
            <thead>
              <tr className="text-start fw-bold fs-7 text-uppercase gs-0">
                <th
                  className="min-w-40px"
                  role="button"
                  onClick={() => toggleSort("worklist_no")}
                >
                  Worklist # <i className={renderSortIcon("worklist_no")}></i>
                </th>
                <th
                  className="min-w-50px"
                  role="button"
                  onClick={() => toggleSort("Client")}
                >
                  Client <i className={renderSortIcon("Client")}></i>
                </th>
                <th
                  className="min-w-50px"
                  role="button"
                  onClick={() => toggleSort("Location")}
                >
                  Location <i className={renderSortIcon("Location")}></i>
                </th>
                <th
                  className="min-w-40px"
                  role="button"
                  onClick={() => toggleSort("Process")}
                >
                  Process <i className={renderSortIcon("Process")}></i>
                </th>
                <th
                  className="min-w-70px"
                  role="button"
                  onClick={() => toggleSort("Specialty")}
                >
                  Specialty <i className={renderSortIcon("Specialty")}></i>
                </th>
                <th
                  className="min-w-200px"
                  role="button"
                  onClick={() => toggleSort("Allocation")}
                >
                  Allocation %
                  <i className={renderSortIcon("Allocation")}></i>
                </th>
                <th className="min-w-200px">Progress %</th>
                <th
                  className="min-w-50px"
                  role="button"
                  onClick={() => toggleSort("changed_by")}
                >
                  Changed By <i className={renderSortIcon("changed_by")}></i>
                </th>
                <th
                  className="min-w-40px"
                  role="button"
                  onClick={() => toggleSort("DateOfService")}
                >
                  Date of Service{" "}
                  <i className={renderSortIcon("DateOfService")}></i>
                </th>
                <th
                  className="min-w-40px"
                  role="button"
                  onClick={() => toggleSort("ReceivedDate")}
                >
                  Received Date{" "}
                  <i className={renderSortIcon("ReceivedDate")}></i>
                </th>
                <th
                  className="min-w-40px"
                  role="button"
                  onClick={() => toggleSort("WorklistStatus")}
                >
                  Status <i className={renderSortIcon("WorklistStatus")}></i>
                </th>
              </tr>
            </thead>

            <tbody className="text-gray-600 fw-semibold">
              {isLoading && (
                <tr>
                  {Array(TOTAL_COLUMNS_COUNT)
                    .fill(null)
                    .map((_, idx) =>
                      TOTAL_COLUMNS_COUNT / 2 === idx ? (
                        <td>
                          <span className="spinner-border h-50px w-50px align-middle text-gray-400" />
                        </td>
                      ) : (
                        <td></td>
                      ),
                    )}
                </tr>
              )}
              {!isLoading &&
                currentData?.map((item) => (
                  <tr key={item?.id} onClick={() => handleRedirect(item?.id)}>
                    <td>
                      <strong className="text-gray-900">
                        {item?.worklist_no}
                      </strong>
                    </td>
                    <td>{item?.Client}</td>
                    <td>{item?.Location}</td>
                    <td>{item?.Process}</td>
                    <td>{item?.Specialty}</td>
                    <td>
                      <div className="d-flex align-items-center flex-column mt-3 w-100">
                        <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                          {item?.no_of_charts != null && (
                            <>
                              <span className="fw-bold fs-6 text-gray-400">
                                {(
                                  100 -
                                  (item?.unallocated_charts_count /
                                    item?.no_of_charts) *
                                    100
                                ).toFixed(2)}
                                %
                              </span>
                              <span className="fw-semibold fs-6 text-dark">
                                {(
                                  (item?.unallocated_charts_count /
                                    item?.no_of_charts) *
                                  100
                                ).toFixed(2)}
                                % pending
                              </span>
                            </>
                          )}
                        </div>
                        {item?.no_of_charts != null ? (
                          <div
                            className={
                              (item?.unallocated_charts_count /
                                item?.no_of_charts) *
                                100 ===
                              0
                                ? "h-8px mx-3 w-100 bg-success rounded"
                                : "h-8px mx-3 w-100 bg-light-warning rounded"
                            }
                          >
                            <div
                              className={
                                (item?.unallocated_charts_count /
                                  item?.no_of_charts) *
                                  100 ===
                                0
                                  ? "bg-success rounded h-8px"
                                  : "bg-warning rounded h-8px"
                              }
                              role="progressbar"
                              style={
                                (item?.unallocated_charts_count /
                                  item?.no_of_charts) *
                                  100 ===
                                0
                                  ? {
                                      width: "100%",
                                      ariaValuenow: "50",
                                      ariaValuemin: "0",
                                      ariaValuemax: "100",
                                    }
                                  : {
                                      width: `${
                                        100 -
                                        (item?.unallocated_charts_count /
                                          item?.no_of_charts) *
                                          100
                                      }%`,
                                      ariaValuenow: "50",
                                      ariaValuemin: "0",
                                      ariaValuemax: "100",
                                    }
                              }
                            ></div>
                          </div>
                        ) : (
                          <div>---</div>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center flex-column mt-3 w-100">
                        <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                          {item?.progressPercentage != null && (
                            <>
                              <span className="fw-bold fs-6 text-gray-400">
                                {item?.progressPercentage}%
                              </span>
                              <span className="fw-semibold fs-6 text-dark">
                                {(100 - item?.progressPercentage).toFixed(2)}%
                                pending
                              </span>
                            </>
                          )}
                        </div>
                        {item?.progressPercentage != null ? (
                          <div className="h-8px mx-3 w-100 bg-light-warning rounded">
                            <div
                              className={
                                item?.progressPercentage > 80
                                  ? "bg-success rounded h-8px"
                                  : "bg-warning rounded h-8px"
                              }
                              style={{ width: `${item?.progressPercentage}%` }}
                            ></div>
                          </div>
                        ) : (
                          <div>---</div>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="symbol-group symbol-hover flex-nowrap">
                        <OverlayTrigger
                          overlay={
                            <Tooltip>{item?.changed_by?.full_name}</Tooltip>
                          }
                          key={item?.changed_by?.id}
                          placement={"right"}
                        >
                          <div
                            className="symbol symbol-35px symbol-circle user-image"
                            data-kt-initialized="1"
                          >
                            <img
                              alt="name"
                              src={
                                item?.changed_by?.image_url ??
                                `../assets/media/avatars/300-${imageIdGenerate(
                                  item?.changed_by?.id,
                                )}.jpg`
                              }
                            />
                          </div>
                        </OverlayTrigger>
                      </div>
                    </td>

                    <td>{moment(item?.DateOfService).format("MM/DD/YYYY")}</td>
                    <td>{moment(item?.ReceivedDate).format("MM/DD/YYYY")}</td>
                    <td>
                      {item?.status != null ? (
                        <div
                          className={
                            item?.status?.toLowerCase() === "open"
                              ? "badge text-warning fw-bold"
                              : item?.status?.toLowerCase() === "closed"
                              ? "badge text-success fw-bold"
                              : "badge text-info fw-bold"
                          }
                        >
                          {item?.status}
                        </div>
                      ) : (
                        <div>---</div>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {currentData?.length === 0 && <div>No Records Found ...</div>}
          {currentData?.length !== 0 && (
            <CustomPagination
              dataPerPage={dataPerPage}
              totalData={postData?.totalRecords}
              paginate={paginate}
              currentPage={currentPage}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default WorkListTable;
